module.exports = __webpack_public_path__ + "img/LOGOEXPANSION_blanco.bbb2621b.webp";